(() => {
  const assetsPromiseKey = '__tdDeliveryAssetsPromise';

  const loadScript = (src, id, ready) => new Promise((resolve, reject) => {
    if (ready()) {
      resolve();
      return;
    }

    const existing = document.getElementById(id);
    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => {
        existing.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    }, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.append(script);
  });

  const ensureAssets = (section) => {
    if (!window[assetsPromiseKey]) {
      window[assetsPromiseKey] = loadScript(
        section.dataset.deliveryMapSrc,
        'td-delivery-map-data-script',
        () => Boolean(window.TDDeliveryMapData),
      ).then(() => loadScript(
        section.dataset.deliveryScriptSrc,
        'td-delivery-care-script',
        () => section.dataset.deliveryReady === 'true',
      )).catch((error) => {
        delete window[assetsPromiseKey];
        throw error;
      });
    }

    return window[assetsPromiseKey];
  };

  const initialize = (section) => {
    if (!section || section.dataset.deliveryLoaderReady === 'true') return;
    section.dataset.deliveryLoaderReady = 'true';

    let observer;
    const load = () => {
      observer?.disconnect();
      ensureAssets(section).catch(() => {
        section.dataset.deliveryLoaderReady = 'false';
        section.dataset.deliveryAssetError = 'true';
      });
    };

    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }

    observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) load();
    }, { rootMargin: '1200px 0px' });
    observer.observe(section);
  };

  const initializeAll = (root = document) => {
    if (root.matches?.('[data-td-delivery]')) initialize(root);
    root.querySelectorAll?.('[data-td-delivery]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
